import React from "react";
import Error from "../routes/error";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import SimpleLoginRoutes from "../routes/simple-login/simple-login-routes"
import AuthRoutes from "../routes/authn/authn-routes";
import OauthRoutes from "../routes/oauth/oauth-routes";
import MsalError from "../routes/msal/msal-error/msal-error";

function App() {
  return (
    <>
      <div id="global-dynamic-content" />
      <Router>
        <Switch>
          {AuthRoutes}
          {OauthRoutes}
          {SimpleLoginRoutes}
          <Route path="/error" component={Error} exact />
          <Route path="/msal-error" component={MsalError} exact />
          <Route render={() => <Redirect to="/error" />} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
